import React from 'react';
import { Alert, Box, Button, Typography } from '@ublend-npm/aulaui-core';
import StudentRow from './StudentRow';
import {
  ExtensionStudent,
  ManageExtensionStyles,
} from './ManageExtension.types';

type Props = {
  errorCode: string;
  onClose: () => void;
  provider?: string;
  students: ExtensionStudent[];
  styles: ManageExtensionStyles;
};

const ExistingSubmissionConflict = ({
  errorCode,
  onClose,
  provider,
  students,
  styles,
}: Props) => {
  const currentExtensionConflict = errorCode === 'extension-submissions-exist';
  let message = currentExtensionConflict
    ? 'The operation couldn’t be completed because the following students still have a submission in the extension. Please delete their submission before removing them from this extension.'
    : 'The operation couldn’t be completed because the following students have submissions. Please delete one of their submissions and try again.';
  if (!currentExtensionConflict && provider === 'turnitin') {
    message =
      'The operation couldn’t be completed because the following students have submissions. Please open this assignment in Turnitin and delete one of their submissions before trying again.';
  }

  return (
    <Box sx={styles.conflictContent}>
      <Typography component="h3" sx={styles.conflictTitle}>
        Existing submissions found
      </Typography>
      <Alert severity="error">{message}</Alert>
      <Box component="ul" sx={styles.conflictStudents}>
        {students.map((student) => (
          <StudentRow
            key={student.id}
            canAdd={false}
            isSelected={false}
            onToggle={() => {}}
            showAction={false}
            student={student}
            styles={styles}
          />
        ))}
      </Box>
      <Box sx={styles.conflictActions}>
        <Button kind="secondary" onClick={onClose}>
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default ExistingSubmissionConflict;
